import { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Alert,
    AlertIcon,
    AlertDescription,
} from "@chakra-ui/react";
import { isPublished } from "../../constants/priceLists";

const DeleteModal = ({ isOpen, onClose, onConfirm, data }) => {
    const [isConfirming, setIsConfirming] = useState(false);

    if (!data) return null;

    const handleConfirm = async () => {
        setIsConfirming(true);
        try {
            await onConfirm();
        } finally {
            setIsConfirming(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent mx={4}>
                <ModalHeader>Obriši cjenik</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text mb={3}>
                        Jeste li sigurni da želite obrisati cjenik <b>{data.fileName}</b>?
                    </Text>
                    {isPublished(data) && (
                        <Alert status="warning" borderRadius="lg">
                            <AlertIcon />
                            <AlertDescription fontSize="sm">
                                Ovaj cjenik je već objavljen i bit će obrisan i iz javne arhive. Brisanje je namijenjeno
                                isključivo ispravku pogrešnog uploada - za promjenu cijena objavite novu verziju.
                            </AlertDescription>
                        </Alert>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme="red"
                        mr={3}
                        onClick={handleConfirm}
                        isLoading={isConfirming}
                        loadingText="Brisanje..."
                        isDisabled={isConfirming}
                    >
                        Obriši
                    </Button>
                    <Button onClick={onClose} isDisabled={isConfirming}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteModal;
